import { GlobalSearchResultsGroupType } from '@api';
import { Spotlight } from '@mantine/spotlight';
import { useTranslation } from 'react-i18next';
import { Action } from './components';

type ActionGroupPropsType = {
  group: GlobalSearchResultsGroupType;
};

export const ActionGroup: React.FC<ActionGroupPropsType> = ({ group }) => {
  const { t } = useTranslation();

  const groupLabel = t(
    `HEADER.SPOTLIGHT_SEARCH.SEARCH_RESULT_TYPES.${group.type}`
  );

  return (
    <Spotlight.ActionsGroup key={group.id} label={groupLabel}>
      {group.results.map((result) => (
        <Action key={result.id} action={result} type={group.type} />
      ))}
    </Spotlight.ActionsGroup>
  );
};
